import { Helmet } from "react-helmet-async"

export default function MetaData({heading}) {
    return (
        <Helmet>
            <title>{`${heading} - Jewellery`}</title>
        </Helmet>
    )
}